<div class="block-schedule__bottom book-ride">
    <h1>{{ 'BOOK_RIDE_PLAN_RIDE' | translate }}</h1>

    <form [formGroup]="planRideForm" (ngSubmit)="submit()" autocomplete="off">
        <ridango-ui-swappable-inputs>
            <ridango-ui-autocomplete-input formControlName="pickupFeature"
                ridangoUntouchOnFocusout
                [label]="'PICKUP' | translate"
                [options]="pickupSuggestions$ | async" [noMargin]="true"
                [icon]="(assetsPath$ | async) + '/input_pin.png'"
                [iconContrast]="(assetsPath$ | async) + '/input_pin-wcag.png'"
                [fullOption]='true'
                [inputDisplayFn]="suggestionsDisplayCallback"
                [hasOptionIcon]="true"
                [optionIconDisplayFn]="optionIconDisplayCallback"
                (onInputChanged)="setPickupValue($event)"
                (onOptionSelected)="onInputPickup($event)">
            </ridango-ui-autocomplete-input>

            <ridango-ui-autocomplete-input formControlName="dropoffFeature"
                ridangoUntouchOnFocusout
                [label]="'DROPOFF' | translate"
                [options]="dropoffSuggestions$ | async" [hasError]="(
                    (pickup.touched && planRideForm.controls.pickupFeature.hasError('required')) ||
                    (dropoff.touched && planRideForm.controls.dropoffFeature.hasError('required'))
                )" [icon]="(assetsPath$ | async) + '/drop-off.png'"
                [iconContrast]="(assetsPath$ | async) + '/drop-off-wcag.png'"
                [fullOption]='true'
                [icon]="(assetsPath$ | async) + '/drop-off.png'"
                [errorMessage]="'PLAN_RIDE_LOCATIONS_REQUIRED_ERROR' | translate"
                [inputDisplayFn]="suggestionsDisplayCallback"
                [hasOptionIcon]="true"
                [optionIconDisplayFn]="optionIconDisplayCallback"
                (onInputChanged)="setDropOffValue($event)"
                (onOptionSelected)="onInputDropoff($event)">
            </ridango-ui-autocomplete-input>
        </ridango-ui-swappable-inputs>

        <div *ngIf="displayMinimumDateError">{{'MINIMUM_ALLOWED_DATE' | translate}}: {{minimumAllowedDateToBookRide | date: dateFormat + ' HH:mm'}}</div>
        <div class="margin-bottom-20">
            <ridango-datepicker
                [minDate]="minimumAllowedDateToBookRide"
                [date]="dateAndTime"
                (dateUpdated)="updateDateField($event)"
                [dateFormat]="dateFormat"
            ></ridango-datepicker>
        </div>

        <div class="margin-bottom-20">
            <label id="vertical-radio-group-label">{{ 'PLAN_RIDE_PRIORITY' | translate }}</label>
            <mat-radio-group formControlName="priority" attr.aria-labelledby="{{ 'PLAN_RIDE_PRIORITY' | translate }}" class="vertical-radio-group">
                <mat-radio-button class="vertical-radio-button" [value]="priorityOptions.PICKUP">
                    {{ 'RIDE_PICKUP_TIME' | translate }}
                </mat-radio-button>
                <mat-radio-button class="vertical-radio-button" [value]="priorityOptions.DROPOFF">
                    {{ 'RIDE_DROPOFF_TIME' | translate }}
                </mat-radio-button>
            </mat-radio-group>
            <mat-error
                *ngIf="planRideForm.controls.priority.touched && planRideForm.controls.priority.hasError('required')">
                {{ 'PLAN_RIDE_PRIORITY_MISSING' | translate }}
            </mat-error>
        </div>

        <ridango-ui-time-input [minDate]="limitSelectableTime ? minimumAllowedDateToBookRide : null" formControlName="time"></ridango-ui-time-input>

        <div class="">
            <button class="btn btn--maximal btn--primary btn--big" type="submit">
                {{ 'BUTTON_NEXT' | translate }}
            </button>
        </div>
    </form>
</div>
